/**
 * @author sai shiva
 * @Date: 2022-09-13 14:35:11
 * @Last Modified by: sai shiva
 * @Last Modified time: 2022-09-13 16:20:42
 */

import { IMG_IMPORTS } from '../../devUtils/assests';

const WEARABLE_CONSTANTS = Object.freeze({
  WEARABLE_KEYPOINTS: [
    {
      avatar_src: IMG_IMPORTS.WEARABLES_TRULY_CONTATCLESS_EXPERIENCE.URL,
      avatar_alt: IMG_IMPORTS.WEARABLES_TRULY_CONTATCLESS_EXPERIENCE.ALT,
      title: 'Truly Contactless Experience',
      desc: 'Tap the key fob on the contactless POS machine and pay up to INR 5000 without entering any pin.',
    },
    {
      avatar_src: IMG_IMPORTS.WEARABLES_FASHIONABLE_FINTECH.URL,
      avatar_alt: IMG_IMPORTS.WEARABLES_FASHIONABLE_FINTECH.ALT,
      title: 'Fashionable Fintech',
      desc: 'Make every payment in style. No cash, cards or UPI scanners. Just tap!',
    },
    {
      avatar_src: IMG_IMPORTS.WEARABLES_FAST_SECURE.URL,
      avatar_alt: IMG_IMPORTS.WEARABLES_FAST_SECURE.ALT,
      title: 'Fast & Secure',
      desc: 'Paying with a key fob is not only fast but also secure! Zaggle key fob are linked with Yes bank, and all payments are approved by the Rupay network. Saving time for Employee and Channel Partners.',
    },
    {
      avatar_src: IMG_IMPORTS.WEARABLES_HASSLE_FREE_SETUP.URL,
      avatar_alt: IMG_IMPORTS.WEARABLES_HASSLE_FREE_SETUP.ALT,
      title: 'Hassle-Free Setup',
      desc: 'Zaggle key fob is linked with a Yes Bank account, making it even more convenient.',
    },
    {
      avatar_src: IMG_IMPORTS.WEARABLES_EASYONLINE_TRANSACTION.URL,
      avatar_alt: IMG_IMPORTS.WEARABLES_EASYONLINE_TRANSACTION.ALT,
      title: 'Easy Online Transactions',
      desc: 'You can use your key fob for online instant transactions. Made for your convenience.',
    },
    {
      avatar_src: IMG_IMPORTS.WEARABLES_EASY_ENABLE_DISABLE.URL,
      avatar_alt: IMG_IMPORTS.WEARABLES_EASY_ENABLE_DISABLE.ALT,
      title: 'Easy Enable and Disable',
      desc: 'Lost the key fob? No worries, user can simply toggle their wearable on and off from the Zaggle app.',
    },
  ],
  WEARABLE_AVAILABLES: [
    {
      key: 1,
      title: 'Download Zaggle App',
    },
    {
      key: 2,
      title: 'Login or Signup',
    },
    {
      key: 3,
      title: 'Complete KYC',
    },
    {
      key: 4,
      title: 'Activate your key fob',
    },
  ],
  WEARABLE_GIFT_REMEMBER_CONTENT_ONE: `Looking for a unique and premium corporate gift? 
  Look no further than Zaggle's Zakey customized key fobs is here. The perfect way to show your employees, 
  channel partners, customers, and clients how much you value them. 
  Our key fobs make for a great coming-of-age gift that celebrates all partnerships and milestones.
  `,
  WEARABLE_GIFT_REMEMBER_CONTENT_TWO: `With Zakey, you can incentivize your employees and channel partners, 
  and reate long-lasting business relationships that will stand the test of time.
  `,
  WEARABLE_ZAKEY_ONE: `Zaggle Zakey is the perfect wearable for those who want to make quick and convenient payments. 
  Zakey is linked to Yes Bank and all payments are approved by the Rupay network, 
  so you can rest assured that your payments are safe and secure.
  `,
  WEARABLE_ZAKEY_TWO: `Zakey is a new-age stylish wearable that will change your payment journey!
    Just use Zakey to transact at any contactless enabled POS device. Hold the
    Zakey in front of the POS device during payment & voila! It&apos;s the perfect gift:
    Fast.Effortless.Secure
  `,
  WEARABLE_ZAKEY_ZAGGLE: `Zaggle is India’s Fastest growing Fintech company, and we are committed towards bringing modern,cutting-edge solutions to existing problems in the banking process.
    The Zaggle key fob is a revolutionary innovation that enhances your channel partners and employees experience and create value for you.
    Spread happiness with your most valued employees and channel partners by bringing Zaggle key fob from the website and then start using it in 4 easy steps.
  `,
  WEARBLE_CAFETERIA: `Zakey Yes Pay RuPay enables fast
    contactless payments at cafeterias, where time is of the
    essence, Super fast transactions and easy payment at
    the checkout are the most significant advantages of
    contactless payment.
  `,
  WEARABLE_TRANSIT_SOLUTION: `An easy tap-and-pay option for paying fares for any transport
    system accepting card payments. A long queue can be
    avoided at the ticket counters if you have ZAKEY. Reach your
    destination on time.
  `,
});

export { WEARABLE_CONSTANTS };



// WEBPACK FOOTER //
// client/containers/Wearables/constants.js